export const admin = "/admin"
export const outbox = `${admin}/outbox`
export const languageManagement = `${admin}/language-management`
